import Vue from "vue"
import { nextTick } from "vue"

import AnalyticsPlugin, {
  AnalyticsService,
  GtmTracker,
  MixpanelTracker
} from "@soenergy/frontend-library/src/plugins/analytics"
import Mixpanel from "@soenergy/frontend-library/src/services/Mixpanel"
import { runOnceCookieIsAllowed } from "@soenergy/frontend-library/src/services/CookiePreferences"
import { PROJECTS } from "@soenergy/frontend-library/src/config/projectRouting"

export default ({ app, beforeNuxtRender, nuxtState }) => {
  const fetchTrackingConfig = async () => {
    const dataSources = [
      "public-website-page-urls",
      "account-site-urls",
      "help-site-urls"
    ]
    const pageNameArrays = await Promise.all(
      dataSources.map(source => app.$storyblokHelper.getDataSource(source))
    )
    return pageNameArrays.flat()
  }
  if (process.server) {
    beforeNuxtRender(async ({ nuxtState }) => {
      nuxtState.analyticsConfig = await fetchTrackingConfig()
    })
  } else {
    Vue.use(AnalyticsPlugin)
    runOnceCookieIsAllowed("performance", () => {
      Mixpanel.init(process.env.VUE_APP_MIXPANEL_TOKEN, {
        projectName: PROJECTS.Website
      })
      AnalyticsService.init({
        trackers: [GtmTracker, MixpanelTracker],
        vueRouter: app.router,
        pageNames: nuxtState.analyticsConfig,
        setGlobalLinkTracking: true,
        nextTick
      })
    })
  }
}
